<script lang="ts">

</script>

<section id="profile-section">
    <div class="profile-section-container">
        <h2 class="profile-section-container__title">プロフィール</h2>
        <div class="container-content">
            <div class="container-content__name">田中涼介
                <span class="container-content__age">21歳</span>
            </div>
            <div class="container-content__hometown">福島県会津喜多方市出身</div>
            <div class="container-content__history">華舞翔新体操倶楽部 / 青森山田高校 / 青森大学</div>
            <div class="container-content__body">
                2022年6月トランポリンでの調整中に首の骨を脱臼、頚椎を損傷する大怪我を負い、現在再生医療をうけリハビリを行なっております。
                腕はかろうじて上がるものの、鎖骨から下の感覚が未だ戻らない状況です。涼介や、彼をを支えているご家族のために1人でも多くの支えが必要です。
                皆様どうか、ご支援とご協力のほどよろしくお願いいたします。
            </div>
        </div>
        <div class="profile-section-container__image-area">
            <img class="profile-section-container__image" src="image/pc/ryosuke-profile-image.jpg" alt="田中涼介プロフィール写真">
        </div>
    </div>
</section>

<style>
    #profile-section {
        padding:          48px 0;
        background-color: #f1f6e7;
    }

    #profile-section .profile-section-container {
        width:      1024px;
        margin:     0 auto;
        text-align: left;
    }

    #profile-section .profile-section-container__title {
        font-size:     40px;
        font-weight:   bold;
        color:         #333333;
        text-align:    center;
        margin-bottom: 56px;
    }

    #profile-section .profile-section-container__title:after {
        display:          block;
        position:         absolute;
        content:          "";
        height:           4px;
        width:            250px;
        background-color: #198130;
        transform:        translate(384px, 16px);
    }

    #profile-section .container-content {
        display:          inline-block;
        width:            456px;
        margin-right:     32px;
        padding:          40px;
        background-color: white;
        border-radius:    8px;
        text-align:       left;
    }

    #profile-section .container-content__name {
        position:      relative;
        margin-bottom: 16px;
        font-size:     50px;
        font-weight:   bold;
        z-index:       2;
    }

    #profile-section .container-content__name::before {
        display:      block;
        content:      "Ryosuke Tanaka";
        position:     absolute;
        color:        #9edc93;
        font-size:    50px;
        font-family:  luxus-brut, cursive;
        font-style:   italic;
        opacity:      0.9;
        transform:    rotate(-3deg);
        transform:    translate(10px, 10px);
        z-index:      -1;
    }

    #profile-section .container-content__age {
        margin-bottom: 8px;
        font-size:     32px;
    }

    #profile-section .container-content__hometown {
        margin-bottom: 8px;
        font-size:     26px;
    }

    #profile-section .container-content__history {
        display:          inline-block;
        margin-bottom:    32px;
        padding:          4px 8px;
        font-size:        18px;
        background-color: #eaf8f4;
    }

    #profile-section .container-content__history:after {
        content:          "";
        position:         absolute;
        display:          block;
        height:           4px;
        width:            440px;
        background-color: #198130;
        transform:        translate(-10px, 16px);
    }

    #profile-section .container-content__body {
        font-size: 20px;
    }
    #profile-section .profile-section-container__image-area {
        position:         absolute;
        display:          inline-block;
        width:            440px;
        padding:          90px 20px 30px;
        background-color: white;
        overflow:         hidden;
        transform:        rotate(-4deg);
        vertical-align:   top;
    }

    #profile-section .profile-section-container__image-area:before {
        content:          "";
        position:         absolute;
        display:          block;
        background-color: #f1f6e7;
        height:           24px;
        width:            24px;
        border-radius:    1em;
        transform:        translate(200px, -60px);
    }

    #profile-section .profile-section-container__image {
        width:      100%;
        height:     100%;
        object-fit: cover;
    }
</style>